import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const StudioDataContext = createContext(null);

// Loads the full read-only intelligence dataset once and shares it across every
// Studio module + global search. All endpoints are the verified Phase-1 read APIs.
export function StudioDataProvider({ children }) {
  const [strategists, setStrategists] = useState(null);
  const [knowledge, setKnowledge] = useState(null); // { entries, domains }
  const [missions, setMissions] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [providers, setProviders] = useState(null);
  const [health, setHealth] = useState(null);
  const [sysHealth, setSysHealth] = useState(null);
  const [requests, setRequests] = useState(null);

  const load = useCallback(() => {
    api.get("/mi/v1/strategists").then((r) => setStrategists(r.data.strategists || [])).catch(() => setStrategists([]));
    api.get("/admin/mi/knowledge").then((r) => setKnowledge(r.data)).catch(() => setKnowledge({ entries: [], domains: [] }));
    api.get("/admin/mission-plans?limit=100").then((r) => setMissions(r.data || [])).catch(() => setMissions([]));
    api.get("/admin/mi/analytics").then((r) => setAnalytics(r.data)).catch(() => setAnalytics(null));
    api.get("/admin/mi/providers").then((r) => setProviders(r.data)).catch(() => setProviders(null));
    api.get("/mi/v1/health").then((r) => setHealth(r.data)).catch(() => setHealth(null));
    api.get("/health").then((r) => setSysHealth(r.data)).catch(() => setSysHealth(null));
    api.get("/admin/mi/requests?limit=50").then((r) => setRequests(r.data || [])).catch(() => setRequests([]));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <StudioDataContext.Provider value={{ strategists, knowledge, missions, analytics, providers, health, sysHealth, requests, reload: load }}>
      {children}
    </StudioDataContext.Provider>
  );
}

export const useStudio = () => useContext(StudioDataContext);
